import React, { Component } from 'react';

export class EmailFormInPage extends Component {
  constructor(props) {
    super(props);
    this.state = { email: '' };
    this.onSubmit = this.onSubmit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
  }

  componentDidMount() {
    const emailInputs = document.querySelectorAll('.email-form-in-page .form-control');
    const emailButtons = document.querySelectorAll('.email-form-in-page .btn-subscribe');

    emailButtons.forEach(function(emailButton) {
      emailButton.addEventListener('mouseenter', e => {
        emailInputs.forEach(function(emailInput) {
          emailInput.classList.add('green');
        });
      });
    });

    emailButtons.forEach(function(emailButton) {
      emailButton.addEventListener('mouseleave', e => {
        emailInputs.forEach(function(emailInput) {
          emailInput.classList.remove('green');
        });
      });
    });

    emailInputs.forEach(function(emailInput) {
      emailInput.addEventListener('focus', e => {
        emailButtons.forEach(function(emailButton) {
          emailButton.classList.add('green');
        });
      });
    });

    emailInputs.forEach(function(emailInput) {
      emailInput.addEventListener('blur', e => {
        emailButtons.forEach(function(emailButton) {
          emailButton.classList.remove('green');
        });
      });
    });
  }

  handleEmailChange(e) {
     this.setState({email: e.target.value});
  }

  onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    const emailFormContainer = document.querySelector('.email-form-in-page');

    if (emailFormContainer) {
      emailFormContainer.classList.add('blurred');
    }

    this.setState({email: e.target.value});

    const emailAddress = this.state.email

    if (document.querySelector("[name='humans-only']").value.length > 0) {

      fetch('/.netlify/functions/email-signup', {
          headers : {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            email_address: emailAddress
          }),
          method: 'POST'
        }).then(response => {
          if (response.status === 200) {
            if (emailFormContainer) {
              emailFormContainer.classList.remove('blurred');
            }
            const emailInputContainers = document.querySelectorAll('.email-form-in-page');
            emailInputContainers.forEach(function(emailInputContainer) {
              emailInputContainer.innerHTML = "Success! You should receive a confirmation email within a few minutes.";
              setTimeout(function() {
                emailInputContainer.remove();
              }, 10000);
            });
          } else {
            window.alert('Oops! Something is not working. Please email us directly at hello@joincrafted.com to sign up.');
          }
        })
    }
  }

  /* Old EmailFormInPage code
      <div className="email-form-in-page d-flex justify-content-center flex-column align-items-center p-3 mb-4 text-center" style={{maxWidth: '410px', margin: 'auto'}}>
        <p className="mb-1 text-center" style={{color: 'rgb(145, 145, 145)'}}>Want inspiration in your inbox? Crafted helps you along in your beer-brewing journey.</p>
        <form id="sign-up" name="sign-up" onSubmit={this.onSubmit} method="POST" action="#" netlify-honeypot="humans-only" className="subscribe-form">
          <p className="d-none">
            <label>Bot trap, not for humans: <input name="humans-only" /></label>
          </p>
          <div className="input-group">
            <input type="email" value={this.state.email || ''} onChange={this.handleEmailChange} className="form-control" placeholder="Your email" aria-label="Your email address" aria-describedby="email" required />
            <div className="input-group-append">
              <button id="btn-subscribe" className="btn btn-subscribe" type="submit">Sign up</button>
            </div>
          </div>
        </form>
      </div>
      */

  render() {
    return (
      <div></div>
    );
  }
}

export default EmailFormInPage;
